// Create an encryptor:
var encryptor = require("simple-encryptor")(process.env.VUE_APP_ENCRYPTION_KEY);

export default encryptor;
